module.exports = __webpack_public_path__ + "static/media/OsSysLogo.537dd609.svg";